import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  action: {
    margin: theme.spacing(1),
    width: '100%',
  },
  actionSecondary: {
    width: '100%',
    // color: 'white', - it's white on white
    borderColor: theme.palette.backdrop.light,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
  },
  closeButton: {
    color: 'white',
    right: 12,
    padding: 8,
    marginTop: -8,
    marginRight: -4,
    position: 'absolute',
  },
  icon: {
    alignSelf: 'center',
    width: '100px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '24px',
    marginTop: theme.spacing(3),
  },
  muiMessage: {
    padding: 0,
  },
  root: {
    padding: 0,
    borderRadius: '20px',
    width: '375px',
  },
  toast: {
    backgroundColor: theme.palette.common.black,
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
  },
  title: {
    color: 'white',
    fontWeight: theme.typography.fontWeightBold,
    margin: `${theme.spacing(1)} ${theme.spacing(1)} 0px`,
    textAlign: 'center',
  },
  message: {
    color: 'white',
    margin: theme.spacing(1),
    textAlign: 'center',
  },
}));
